/* accruedCommissions.js -- THE ACCRUED-COMMISSIONS LINK (commission ship 4, 2026-10-09). The sibling of accruedPayroll.js.
 *
 * A company that ACCRUES commissions (companies.commission_books = 'accrues') carries a liability at each month-end: commission
 * EXPENSED (Brian B1: in the month earned, or at the cycle's last month under 'period_end') and not yet PAID (cycle close + the
 * payment lag). computePayroll produces that series (result.accruedCommissions); this file is the ONE owner of how it reaches the
 * balance sheet, so the parties that must agree read the same rules:
 *
 *   buildBSLines   wires the operator's linked account to the series       accruedCommissionsLinkKey  (the rule)
 *   orchestrator   serves the series only where the builder wired it       accruedCommissionsBuiltKey (asked of the BUILT skeleton)
 *   computeBS      UNCHANGED -- its module_link arm reads IS_REF['accrued_commissions'] for the wired leaf
 *   preflightCheck P23 (e / e2 / f) and P24 ask the same questions
 *
 * No synthetic line is ever made: the account is one of the company's own accrued-liability lines, never the accrued-payroll
 * account -- ship 3's commissionAccrual.js commissionAccountRefusal decides, reused here. Closed months stay the imported ledger;
 * the engine's balance starts with the first forecast month, so the GL close balance minus the computed one passes through cash in
 * that month (Q1 b / N2: no tax) -- P24 names the amount.
 *
 * PURE. Plain ASCII on purpose (CLAUDE.md 12.5 rule 55). Design: diffs/commission-accrual-design-v2.txt D6. */
import { accruesCommissions, commissionAccountRefusal } from './commissionAccrual';

// The IS_REF key computeBS's module_link arm reads for the linked account.
export const ACCRUED_COMMISSIONS_REF = 'accrued_commissions';

/* THE RULE the builder wires by. accrual = commissionAccrualFromSettings(...); accruedPayrollKey = companies.accrued_payroll_bs_line_key.
   Returns the line key to wire, or null:
     the company accrues commissions, AND an account is linked, AND it passes commissionAccountRefusal (one of THIS company's
     stored-'accrued' lines with a label, and not the accrued-payroll account), AND no other stream already links it (taken = the
     keys the revenue modules, the implementation lines and the accrued payroll wired -- a leaf is never wired twice). */
export function accruedCommissionsLinkKey(accrual, bsActualsMeta, taken, accruedPayrollKey) {
  if (!accruesCommissions(accrual)) return null;
  const key = accrual.lineKey;
  if (!key || typeof key !== 'string') return null;
  if (commissionAccountRefusal(key, bsActualsMeta, accruedPayrollKey || null)) return null;
  if (taken && key in taken) return null;
  return key;
}

// The id of the BUILT balance-sheet leaf that carries the accrued-commissions ref, or null. Asked of the skeleton the builder
// produced, so whoever serves or checks the series cannot disagree with the builder about where it lands.
export function accruedCommissionsBuiltKey(bsLines) {
  const l = (bsLines || []).find(x => x && x.module_link_ref === ACCRUED_COMMISSIONS_REF);
  return l ? l.id : null;
}
